import { useNotify } from 'react-admin'
import { Button } from 'shared/components/Button/Button'
import { ConfirmDialog } from 'shared/components/Dialog/ConfirmDialog'
import { Text } from 'shared/components/Text/Text'
import { useOnboardingChecklist } from 'shared/hooks/query/useOnboardingChecklist'
import { deactivateCandidate } from 'shared/models/backgroundCheck'
import { User } from 'shared/models/user'
import { midGray } from 'shared/theme/colors'

interface UserOnboardingDeactivateCheckrCandidateProps {
  user: User
}

export function UserOnboardingDeactivateCheckrCandidate({
  user,
}: UserOnboardingDeactivateCheckrCandidateProps) {
  const notify = useNotify()
  const { refetch } = useOnboardingChecklist(user.id, { enabled: false })

  async function onSubmit() {
    await deactivateCandidate(user.id)
    notify('Checkr candidate deactivated', { type: 'success' })
    refetch()
  }

  return (
    <ConfirmDialog
      width="390px"
      dialogContent={
        <>
          <Text variant="header2" align="left">
            Deactivate Checkr Candidate
          </Text>
          <Text variant="paragraph1" align="left" mt={1} fontColor={midGray}>
            Do you want to proceed?
          </Text>
        </>
      }
      confirmLabel="Yes"
      cancelLabel="No"
      handleConfirm={onSubmit}
      handleError={(err) => notify(JSON.stringify(err), { type: 'error' })}
    >
      <Button variant="text" size="small">
        Deactivate Checkr Candidate
      </Button>
    </ConfirmDialog>
  )
}
